module.exports = __webpack_public_path__ + "img/webp_3.38285d86.gif";